import { render } from "./BookmarkList.vue?vue&type=template&id=bd5edb98&scoped=true"
import script from "./BookmarkList.vue?vue&type=script&lang=js"
export * from "./BookmarkList.vue?vue&type=script&lang=js"

import "./BookmarkList.vue?vue&type=style&index=0&id=bd5edb98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5edb98"]])

export default __exports__